import PropTypes from 'prop-types';
import ShoppingListCategory from '../Content/Category/ShoppingListCategory';
import { Alert } from 'reactstrap';
import {
  getCountry,
  useTranslator,
  useAppContext,
  withLoading,
} from '@front-activerse/common-components';
import PeriodInfo from './PeriodInfo/PeriodInfo';
import InstacartButton from './InstacartButton';
import FriscoButton from './FriscoButton';
import ShoppingTipsAlert from '../Alerts/ShoppingTipsAlert';
import ShoppingListContentPlaceholder from '../Placeholder/ShoppingListContentPlaceholder';

const ShoppingListContent = ({ categories, periodCoverage, start, end, shoppingTipsArticleId }) => {
  const { t } = useTranslator();

  const {
    consts: { INSTACART_FIREBASE_FUNCTION, INSTACART_URL, FRISCO },
    images: { infoIcon },
  } = useAppContext();

  let showInstacartButton = false;

  if (getCountry() === 'Canada' || getCountry() === 'United States of America') {
    showInstacartButton = true;
  }

  let showFriscoButton = false;
  if (getCountry() === 'Poland') {
    showFriscoButton = true;
  }

  console.log('FRISCO', FRISCO);

  return (
    <>
      {periodCoverage ? (
        <Alert color="warning" className="mb-4" fade={false}>
          <p className="small">{t('shoppingList.notification.noWholeRange')}</p>
        </Alert>
      ) : (
        ''
      )}

      <PeriodInfo start={start} end={end} />

      {INSTACART_FIREBASE_FUNCTION && INSTACART_URL && showInstacartButton && (
        <InstacartButton categories={categories} start={start} end={end} />
      )}

      {FRISCO && showFriscoButton && <FriscoButton categories={categories} />}

      <div className="ingredient-info-notification d-flex align-items-center">
        <img src={infoIcon} className="me-s" alt="" />
        <p>{t('app.shoppingList.ingredientWeightInfo.content')}</p>
      </div>

      {categories.map(({ categoryId, ...category }) => (
        <ShoppingListCategory key={categoryId} {...category} />
      ))}
      <hr className="my-xl" />
      <ShoppingTipsAlert shoppingTipsArticleId={shoppingTipsArticleId} />
    </>
  );
};

ShoppingListContent.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      categoryId: PropTypes.number.isRequired,
      products: PropTypes.array.isRequired,
    })
  ).isRequired,
  periodCoverage: PropTypes.bool.isRequired,
  start: PropTypes.string.isRequired,
  end: PropTypes.string.isRequired,
  shoppingTipsArticleId: PropTypes.number.isRequired,
};

export default withLoading(ShoppingListContent, ShoppingListContentPlaceholder);
